import { render } from "./APIKey.vue?vue&type=template&id=3a22f9e1&scoped=true"
import script from "./APIKey.vue?vue&type=script&lang=js"
export * from "./APIKey.vue?vue&type=script&lang=js"

import "./APIKey.vue?vue&type=style&index=0&id=3a22f9e1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3a22f9e1"

export default script